import {
    getHostsAll,
    getHostsDetail,
    putHostsDetail,
    putHostsDetailAdminMemo,
} from "../../../../../communication_system/axios_apis/axios_apis";
import createGetRequestThunk from "../../redux_functions/create_get_request_thunk";
import createPutRequestThunk from "../../redux_functions/create_put_request_thunk";
import {GET_HOSTS_ALL, GET_HOSTS_DETAIL, PUT_HOSTS_DETAIL, PUT_HOSTS_DETAIL_ADMIN_MEMO,} from "./hosts_detail_type";

export const getHostsDetailAsync = createGetRequestThunk(
  GET_HOSTS_DETAIL,
  getHostsDetail
);

export const putHostsDetailAdminMemoAsync = createPutRequestThunk(
  PUT_HOSTS_DETAIL_ADMIN_MEMO,
  putHostsDetailAdminMemo
);

export const putHostsDetailAsync = createPutRequestThunk(
  PUT_HOSTS_DETAIL,
  putHostsDetail
);
export const getAllHostsAsync = createGetRequestThunk(
    GET_HOSTS_ALL,
    getHostsAll
)
